import { useMutation, useQueryClient } from '@tanstack/react-query';
import { WbsAdjustmentRequestDto } from 'src/api/FiretrolApiClient';
import { wbsApiClient } from 'src/api/FiretrolApiClientInstances';
import { invalidateFor } from 'src/api/queries/invalidationMap';

export function useWbsAdjustmentMutations(jobId: number, accountId: string) {
  const qc = useQueryClient();
  const settle = () =>
    invalidateFor('wbsAdjustment.save', qc, { jobId, accountId });

  const createAdjustment = useMutation({
    mutationFn: (request: WbsAdjustmentRequestDto) =>
      wbsApiClient.createAdjustment(accountId, request),
    onSettled: settle,
  });

  const updateAdjustment = useMutation({
    mutationFn: ({
      adjustmentId,
      request,
    }: {
      adjustmentId: string;
      request: WbsAdjustmentRequestDto;
    }) => wbsApiClient.updateAdjustment(adjustmentId, request),
    onSettled: settle,
  });

  const deleteAdjustment = useMutation({
    mutationFn: (adjustmentId: string) =>
      wbsApiClient.deleteAdjustment(adjustmentId),
    onSettled: settle,
  });

  return { createAdjustment, updateAdjustment, deleteAdjustment };
}
